/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Storage JSON Schemas 

const _ATTACHED_STORAGE_FILES_JSON_SCHEMA = {
    "$ref": "#/definitions/AttachedStorageFilesSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "AttachedStorageFilesSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "attached_files_uid": {
                    "reference_type": "uuid",
                    "title": "Attached Files Uid",
                    "type": "string",
                    "uid_resource_type": "attached_storage_files"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "creating_account_uid": {
                    "reference_type": "uuid",
                    "title": "Creating Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "file_uids": {
                    "items": {
                        "title": "file_uids",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "File Uids",
                    "type": "array",
                    "uid_resource_type": "storage_file"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                }
            },
            "required": [
                "attached_files_uid",
                "created_timestamp",
                "creating_account_uid",
                "file_uids",
                "last_updated_timestamp",
                "resource_type",
                "resource_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};

const _STORAGE_FILE_JSON_SCHEMA = {
    "$ref": "#/definitions/StorageFileSchema",
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "StorageFileSchema": {
            "additionalProperties": false,
            "properties": {
                "account_uids_with_read_permission": {
                    "items": {
                        "title": "account_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Account Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "bucket_file_name": {
                    "title": "Bucket File Name",
                    "type": "string"
                },
                "bucket_folder_path": {
                    "title": "Bucket Folder Path",
                    "type": "string"
                },
                "bucket_name": {
                    "title": "Bucket Name",
                    "type": "string"
                },
                "created_timestamp": {
                    "format": "date-time",
                    "title": "Created Timestamp",
                    "type": "string"
                },
                "deleted": {
                    "title": "Deleted",
                    "type": "boolean"
                },
                "deleted_timestamp": {
                    "format": "date-time",
                    "title": "Deleted Timestamp",
                    "type": "string"
                },
                "deleting_account_uid": {
                    "reference_type": "uuid",
                    "title": "Deleting Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                },
                "deposify_tags": {
                    "items": {
                        "format": "integer",
                        "title": "deposify_tags",
                        "type": "number"
                    },
                    "title": "Deposify Tags",
                    "type": "array"
                },
                "file_extension": {
                    "maxLength": 10,
                    "title": "File Extension",
                    "type": "string"
                },
                "file_type": {
                    "class_name": "StorageFileType",
                    "enum": [
                        "image",
                        "attachment",
                        "system"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "file_uid": {
                    "reference_type": "uuid",
                    "title": "File Uid",
                    "type": "string",
                    "uid_resource_type": "storage_file"
                },
                "last_updated_timestamp": {
                    "format": "date-time",
                    "title": "Last Updated Timestamp",
                    "type": "string"
                },
                "organization_uids_with_read_permission": {
                    "items": {
                        "title": "organization_uids_with_read_permission",
                        "type": "string"
                    },
                    "reference_type": "uuid",
                    "title": "Organization Uids With Read Permission",
                    "type": "array",
                    "uid_resource_type": "user_account"
                },
                "original_file_name": {
                    "title": "Original File Name",
                    "type": "string"
                },
                "resource_type": {
                    "class_name": "ResourceType",
                    "enum": [
                        "unknown_resource_type",
                        "user_account",
                        "user_account_balance",
                        "user_account_balance_source",
                        "user_history_entry",
                        "balance_change_log",
                        "international_user_bank_account",
                        "us_domestic_user_bank_account",
                        "user_bank_account_delta",
                        "user_account_settings",
                        "user_account_admin_ghost",
                        "user_account_finalization",
                        "third_party_user_account_mapping",
                        "previous_email_address",
                        "pending_email_change",
                        "archived_pending_email_change",
                        "password",
                        "expired_password",
                        "password_reset",
                        "deposit",
                        "deposit_invite",
                        "deposit_adjustment",
                        "deposit_interest",
                        "deposit_history_entry",
                        "deposit_close_request",
                        "deposit_user_stats",
                        "deposit_bank_mapping",
                        "deposits_bulk_import",
                        "deposit_interest_log",
                        "archived_deposit_close_request",
                        "deposit_withheld_funds",
                        "pmc_report_timetable",
                        "deposit_group",
                        "deposit_post_close_adjustment",
                        "deposit_user_group",
                        "property_group",
                        "property_user_group",
                        "dispute",
                        "dispute_split",
                        "dispute_intervention_request",
                        "property",
                        "property_address",
                        "compliance",
                        "compliance_rule",
                        "compliance_history",
                        "email_template",
                        "email_verification",
                        "email_verification_record",
                        "email_event",
                        "sent_email",
                        "mailbox",
                        "mailbox_meta_data",
                        "mailbox_message",
                        "permission_entry",
                        "permission_log_entry",
                        "permissions_organization_settings",
                        "resource_permissions",
                        "organization",
                        "organization_resource_permission_rule",
                        "invoice",
                        "invoice_item",
                        "payment_request",
                        "stripe_payment_log",
                        "user_withdraw",
                        "priority_ach_payment",
                        "priority_ach_recurring_payment",
                        "loan_application",
                        "loan_system_info",
                        "loan",
                        "loan_history",
                        "loan_payment_log",
                        "stripe_webhook_log",
                        "user_account_payment_provider_info",
                        "sezzle_order",
                        "sezzle_webhook_event",
                        "bank_account",
                        "bank_account_historical_interest_rate",
                        "bank_account_interest",
                        "bank_account_balance_record",
                        "bank_transfer",
                        "bulk_funds_transfer",
                        "funds_lock",
                        "funds_lock_release_log",
                        "released_funds_lock",
                        "balance_source_transfer",
                        "credit_user_account_log",
                        "event",
                        "event_hook",
                        "notification",
                        "action_item",
                        "update_log_entry",
                        "storage_file",
                        "attached_storage_files",
                        "pre_uploaded_file",
                        "system_history_entry",
                        "snapshot",
                        "ip_address",
                        "known_ip_address",
                        "user_agent",
                        "known_user_agent",
                        "basic_user_account_info",
                        "system_stats",
                        "resource_note",
                        "deposify_tag",
                        "permanent_link",
                        "online_user",
                        "frontend_general_settings",
                        "yardi_screening_works_pro_xml",
                        "yardi_voyager_xml",
                        "yardi_voyager_transaction",
                        "yardi_voyager_resident",
                        "yardi_voyager_resident_custom_column",
                        "yardi_voyager_property_unit",
                        "yardi_voyager_property",
                        "yardi_voyager_pmc_service_interface_version",
                        "yardi_voyager_pmc",
                        "yardi_voyager_pmc_credentials",
                        "yardi_voyager_pet",
                        "yardi_voyager_ils_guest_card_event",
                        "yardi_voyager_charge",
                        "yardi_voyager_charge_code",
                        "yardi_voyager_deposit_create_intent",
                        "yardi_voyager_deposit_close_intent",
                        "yardi_voyager_deposit_withhold_intent",
                        "yardi_voyager_event",
                        "yardi_voyager_flex_deposit_intent",
                        "yardi_voyager_phone",
                        "yardi_voyager_other_occupant",
                        "yardi_voyager_pmc_custom_column_settings",
                        "yardi_voyager_pmc_stats",
                        "yardi_voyager_pmc_stats_collector",
                        "yardi_voyager_active_scan_log_entry",
                        "yardi_voyager_system_settings"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "resource_uid": {
                    "reference_type": "uuid",
                    "title": "Resource Uid",
                    "type": "string"
                },
                "size_in_bytes": {
                    "format": "integer",
                    "maximum": 9223372036854775807,
                    "minimum": -9223372036854775807,
                    "title": "Size In Bytes",
                    "type": "number"
                },
                "state": {
                    "class_name": "StorageFileState",
                    "enum": [
                        "awaiting_upload",
                        "awaiting_finalization",
                        "awaiting_virus_scan",
                        "virus_scan_failed",
                        "available",
                        "disabled"
                    ],
                    "reference_type": "enum",
                    "type": "string"
                },
                "uploaded_timestamp": {
                    "format": "date-time",
                    "title": "Uploaded Timestamp",
                    "type": "string"
                },
                "uploading_account_uid": {
                    "reference_type": "uuid",
                    "title": "Uploading Account Uid",
                    "type": "string",
                    "uid_resource_type": "user_account"
                }
            },
            "required": [
                "bucket_file_name",
                "bucket_folder_path",
                "bucket_name",
                "created_timestamp",
                "deleted",
                "deleted_timestamp",
                "deleting_account_uid",
                "deposify_tags",
                "file_extension",
                "file_type",
                "file_uid",
                "last_updated_timestamp",
                "original_file_name",
                "resource_type",
                "resource_uid",
                "size_in_bytes",
                "state",
                "uploaded_timestamp",
                "uploading_account_uid"
            ],
            "type": "object",
            "ui_info": {
                "hidden_body_fields": [],
                "hidden_table_fields": []
            }
        }
    }
};


export const ATTACHED_STORAGE_FILES_JSON_SCHEMA = _ATTACHED_STORAGE_FILES_JSON_SCHEMA.definitions.AttachedStorageFilesSchema;
export const STORAGE_FILE_JSON_SCHEMA = _STORAGE_FILE_JSON_SCHEMA.definitions.StorageFileSchema;
